import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import getUser from '../services/user/getUser';

import logo from '../assets/images/logo/agentbuzz200.png';
import defaultAvatar from '../assets/images/user-avatar.png';

const styles = theme => ({
  root: {
    maxWidth: 300,
    // minHeight: '100vh',
    paddingTop: 18,
    paddingLeft: 30,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 35,
  },
  avatar: {
    margin: 10,
    width: 50,
    height: 50,
  },
  link: {
    textDecoration: 'none',
  },
  logo: {
    margin: 20,
    maxWidth: 120,
  },
  userName: {
    color: '#5C6BC0',
    fontSize: '1.1rem',
  },
  toolbar: theme.mixins.toolbar,

  navWrapper: {
    padding: '20px 0 20px 20px',
    '& a': {
      textDecoration: 'none',
      color: '#424242',
    },
  },
  signOutBtn: {
    padding: 2,
    fontSize: '0.7rem',
    marginLeft: 8,
  },
  navItem: {
    color: '#424242',
    fontSize: 16,
  },
});

class SidebarNav extends Component {
  state = {};

  async componentDidMount() {
    const user = await getUser();
    const name = user.firstName + ' ' + user.lastName;
    window.Intercom('boot', {
      app_id: window.APP_ID,
      email: user.email,
      name: name,
    });
    this.setState({
      name,
    });
  }
  render() {
    const { classes, handleLogout } = this.props;
    const { name } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.toolbar}>
          <img className={classes.logo} src={logo} alt="AgentBuzz Logo" />
        </div>
        <Divider />
        <div className={classes.row}>
          <Avatar alt={name} src={defaultAvatar} className={classes.avatar} />

          <Link to="/home/account-settings" className={classes.link}>
            <Typography className={classes.userName} variant="headline">
              {name}
            </Typography>
          </Link>
          <Button
            className={classes.signOutBtn}
            variant="flat"
            onClick={handleLogout}
          >
            Sign Out
          </Button>
        </div>
        <Divider />
        <div>
          <div className={classes.navWrapper}>
            <Link to="/home/listings">
              <Typography className={classes.navItem}>Listings</Typography>
            </Link>
          </div>
          <div className={classes.navWrapper}>
            <Link to="/home/leads">
              <Typography className={classes.navItem}>Leads</Typography>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(SidebarNav);



// WEBPACK FOOTER //
// ./src/components/SidebarNav.js